// @ts-nocheck
import React from 'react';
import KwPanel from '../../../common/KwPanel';
import FormInput from '../../../common/FormInput';
import { useTranslation } from 'react-i18next';

const DisabledReasonForm = ({ disabledReason, register, errors }) => {
  const { t } = useTranslation();

  return disabledReason ? (
    <KwPanel className="mb-4 pb-3">
      <FormInput
        register={register}
        required={true}
        error={errors.reason}
        errorMessage={t('Required')}
        name="reason"
        label={t('Reason')}
        defaultValue={disabledReason.reason || ''}
        autoFocus={true}
        testId="disabled-reason-name"
      />
    </KwPanel>
  ) : (
    ''
  );
};



export default DisabledReasonForm;
